import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

export const useDisconnecting = () => {

    const [disconnecting, setDisconnecting] = useState(false);
    const leaveLiveSessionRequest = useSelector((state) => state.api.leaveLiveSession?.request);

    useEffect(() => {
        if (leaveLiveSessionRequest && !disconnecting) {
            setDisconnecting(true);
        } else {
            setTimeout(() => {
                setDisconnecting(false);
            }, 1000)
        }
    }, [leaveLiveSessionRequest]);

    return disconnecting;
}